module.exports = __webpack_public_path__ + "img/logo-euroespes-blanco.75d3e1fc.png";